import React from "react";
import { useAuth } from "../contexts/AuthContext";
import NotFound from "./NotFound";

const AdminRoute = ({ children }) => {
  const { isEffectivelyAdmin, isAuthenticated } = useAuth();

  // If not authenticated, show 404 (don't reveal that the route exists)
  if (!isAuthenticated) {
    return <NotFound />;
  }

  // A platform-only super admin (no entered tenant) is not effectively an
  // admin of anything — these pages are tenant-scoped, same boundary the
  // Sidebar already enforces (RPAA-213).
  if (!isEffectivelyAdmin()) {
    return <NotFound />;
  }

  return children;
};

export default AdminRoute;
